import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GraphQLFundDataService,
  FundDataServiceParams,
} from './graphql-fund-data.service';
import { DocumentNode } from '@apollo/client/core';
import { Logger } from '@utils/logger';
import { Apollo } from 'apollo-angular';
import { ProductDTO } from '@types';
import { MapperParams } from '@products/utils/mappers/type.mapper';
import { map } from 'rxjs/operators';
import { ProductMapper } from '@products/utils/mappers/product.type.mapper';
import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { SiteConfigService } from '@services/site-config.service';

const logger = Logger.getLogger('FundDetailService');

@Injectable({
  providedIn: 'root',
})
export class FundDetailService extends GraphQLFundDataService {
  constructor(
    apollo: Apollo,
    siteConfigService: SiteConfigService,
    private productMapperFactory: MapperFactory
  ) {
    super(apollo, siteConfigService);
  }

  public register(
    query: DocumentNode,
    fundDataServiceParams: FundDataServiceParams
  ): Observable<any> {
    return super.register(query, this.getVariables(fundDataServiceParams)).pipe(
      map((productDetail) => {
        const productDto: ProductDTO = productDetail?.data?.ProductDetails
          ? productDetail.data.ProductDetails
          : null;
        const mappperParams: MapperParams = {
          config: this.siteConfigService,
          includeSoftClosed: true,
        };

        return productDto
          ? this.productMapperFactory
              .createMapper(ProductMapper, mappperParams)
              .toDomain(productDto)
          : null;
      })
    );
  }

  /**
   * Return required variables value to graphql query.
   * @param fundDataServiceParams params required for graphql query
   */
  private getVariables(
    fundDataServiceParams: FundDataServiceParams
  ): Record<string, any> {
    return {
      countrycode: this.getCountry(),
      languagecode: this.getLanguage(),
      fundid: fundDataServiceParams.fundId,
    };
  }
}
